export interface ISageImportOptMap {
  products: boolean
  productLocations: boolean | "updatesOnly"
  customers: boolean
  suppliers: boolean
  invoiceItems: boolean
  stockOrders: boolean
  warehouses: boolean
  productGroups: boolean
  analysisCodes: boolean
  currencies: boolean
  serialNumbers: boolean
  unallocatedOrderItems: boolean
  nominalTransactions: boolean
  purchaseOrderItems?: number
  transactions?: number | boolean
  productLocationWarehouseSageIds?: number[]
  purchaseOrders?: boolean
}

interface IImportMap {
  all: ISageImportOptMap
  full: ISageImportOptMap
  fuller: ISageImportOptMap
  lite: ISageImportOptMap
  stockOnly: ISageImportOptMap
}

export const sageImportOpts: IImportMap = {
  all: {
    products: true,
    productLocations: true,
    customers: true,
    suppliers: true,
    invoiceItems: true,
    stockOrders: true,
    warehouses: true,
    productGroups: true,
    analysisCodes: true,
    currencies: true,
    serialNumbers: true,
    unallocatedOrderItems: true,
    nominalTransactions: true,
    purchaseOrders: true,
    purchaseOrderItems: 200,
    transactions: false,
  },
  full: {
    products: true,
    productLocations: true,
    customers: true,
    suppliers: true,
    invoiceItems: false,
    stockOrders: true,
    warehouses: true,
    productGroups: true,
    analysisCodes: true,
    currencies: true,
    serialNumbers: false,
    unallocatedOrderItems: false,
    nominalTransactions: true,
    purchaseOrders: true,
    purchaseOrderItems: 200,
    transactions: false,
  },
  fuller: {
    products: true,
    productLocations: true,
    customers: true,
    suppliers: true,
    invoiceItems: true,
    stockOrders: true,
    warehouses: true,
    productGroups: true,
    analysisCodes: true,
    currencies: true,
    serialNumbers: true,
    unallocatedOrderItems: true,
    nominalTransactions: true,
    purchaseOrders: true,
    purchaseOrderItems: 200,
    transactions: false,
  },
  lite: {
    products: true,
    productLocations: true,
    customers: true,
    suppliers: true,
    invoiceItems: false,
    stockOrders: true,
    warehouses: true,
    productGroups: false,
    analysisCodes: true,
    currencies: false,
    serialNumbers: false,
    unallocatedOrderItems: false,
    nominalTransactions: false,
    purchaseOrders: true,
    purchaseOrderItems: 200,
    transactions: false,
  },
  stockOnly: {
    products: true,
    productLocations: true,
    customers: false,
    suppliers: false,
    invoiceItems: false,
    stockOrders: false,
    warehouses: false,
    productGroups: false,
    analysisCodes: false,
    currencies: false,
    serialNumbers: false,
    unallocatedOrderItems: false,
    nominalTransactions: false,
  },
}
